module.exports = __webpack_public_path__ + "img/shot_bigtx122402.e9c60812.png";